import React, { useState, useEffect } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { ENDPOINTS } from '../../utils/EndPoint';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiPost } from '../../utils/Api';
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa';

function AdminQuestionAnswers() {
  const location = useLocation();

  const ocean_id = location.state?.ocean_id;
  const stage_id = location.state?.stage_id;
  const lesson_id = location.state?.lesson_id;

  const [questions, setQuestions] = useState([]);
  const [ocean, setQuest] = useState({});

  const navigate = useNavigate();



  useEffect(() => {
    console.log(audioSrc, "audioSrcaudioSrcaudioSrc");

    lessonDetail();
    fetchQuestions();
  }, [ocean_id, stage_id, lesson_id]);

  const fetchQuestions = () => {
    const payload = {
      ocean_id: ocean_id,
      stage_id: stage_id,
      lesson_id: lesson_id,
    };

    apiPost(
      ENDPOINTS.AdminQuestionsAnswers,
      payload,
      (res) => {
        setQuestions(res?.data?.data);
      },
      (err) => {
        console.log(err, 'Error fetching questions');
      }
    );
  };

  const lessonDetail = async () => {
    let payload = {
      lesson_id: lesson_id,
    };
    apiPost(
      ENDPOINTS.AdminLessonDetailByID,
      payload,
      (res) => {
        const questData = res?.data;
        setQuest(questData);
      },
      (err) => {
        console.log("Error:", err);
      }
    );
  };

  const audioSrc = ocean?.lesson_audio
  ? `${process.env.REACT_APP_BASE_URL}/storage/${ocean.lesson_audio}`
  : '';

  useEffect(() => {
    console.log(audioSrc, "audioSrcaudioSrcaudioSrc");


  }, []);


  const handleAudioControl = (action) => {
    const audioElement = document.getElementById('lesson-audio');
    if (audioElement) {
      if (action === 'play') {
        audioElement.play();
      } else if (action === 'pause') {
        audioElement.pause();
      }
    }
  };


  const deleteQuestion = (questionId) => {
    const payload = {
      id: questionId,
    };
    if (questions.length - 1 >= ocean.total_questions) {
      apiPost(
        ENDPOINTS.AdminDeleteQuestion,
        payload,
        (res) => {
          setQuestions(prevQuestions => prevQuestions.filter(question => question.id !== questionId));
        },
        (err) => {
          console.log(err, 'Error deleting question');
        }
      );
    } else {
      alert("You cannot delete the question because it would reduce the total number of questions below the allowed limit for this lesson.");
    }
  };

  const handleAddQuestionAnswersOnClick = () => {
    navigate(`/super-admin/add-question-answers`, {
      state: { ocean_id: ocean_id, stage_id: stage_id, lesson_id: lesson_id },
    });
  };

  const handleEditQuestionAnswersOnClick = (question_id) => {
    navigate(`/super-admin/edit-question-answers/${question_id}`, {
      state: { ocean_id: ocean_id, stage_id: stage_id, lesson_id: lesson_id },
    });
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-4 mt-2">
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="mb-0">Lesson Details</h5>
            </div>
            <div className="card-body">
              <p><strong>Title:</strong> {ocean?.name}</p>
              <p><strong>Ocean Name:</strong> {ocean?.stage?.name}</p>
              <p><strong>Stage Name:</strong> {ocean?.ocean?.name}</p>
              <p><strong>Number Of Questions:</strong> {ocean?.total_questions}</p>
              <p><strong>Description:</strong> {ocean?.description ? ocean.description.replace(/<[^>]*>/g, '') : ''}</p>
              {ocean?.lesson_audio && (
                <div>
                  <strong>Lesson Audio:</strong>
                  <audio
                    id="lesson-audio"
                    src={audioSrc}
                    className="d-block mt-2"
                    controls
                  />                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-lg-8 mt-2">
          <div className="container">
            <div className="d-flex justify-content-between align-items-center">
              <h2 className="mb-4">Questions and Answers</h2>
              <button className="mb-4 btn btn-primary" onClick={handleAddQuestionAnswersOnClick}>
                Add Question & Answers
              </button>
            </div>
            <Accordion>
              {questions.map((question, index) => (
                <Accordion.Item eventKey={String(index)} key={question.id}>
                  <Accordion.Header>
                    {question.qst_no + 1}. {question.question}
                    <div className="ms-2 d-flex align-items-center">
                      <FaPencilAlt
                        className="me-3 text-primary cursor-pointer"
                        onClick={() => handleEditQuestionAnswersOnClick(question.id)}
                      />
                      <FaTrashAlt
                        className="text-danger cursor-pointer"
                        onClick={() => {
                          if (window.confirm("Are you sure you want to delete this question?")) {
                            deleteQuestion(question.id);
                          }
                        }}
                      />
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <h5>Answers:</h5>
                    <ul>
                      {question.answers.map((answer) => (
                        <li key={answer.id}>
                          <strong>{answer.is_correct ? 'Correct' : 'Incorrect'}:</strong>{' '}
                          {answer.answer}
                        </li>
                      ))}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminQuestionAnswers;
